import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Box, Button, IconButton, Paper, TextField, Tooltip, Typography } from "@mui/material";

import NavPrimaryButtonMk2 from "../../theme/NavPrimaryButtonMk2";
import { useCookies } from "react-cookie";
import CollapseInfos from "../Common/CollapseInfos";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { ValidatePwd } from "../Common/helpers";
export default function PwdSet(props) {
	console.log(props);
	const [complete, setComplete] = useState(false);


	const [formData, setFormData] = useState({ pwd1: "", pwd2: null });

	const [devMode, setDevMode] = useState(window.location.href.startsWith("http://localhost"));
	const handleChange = (event) => {
		setFormData({ ...formData, [event.target.name]: event.target.value }, () => {
			console.log("done");
		});
	};

	useEffect(() => {
		console.log(formData);
		if (formData.pwd1 !== "" && formData.pwd1 === formData.pwd2 && ValidatePwd(formData.pwd1)) {
			setComplete(true);
		} else {
			setComplete(false);
		}
	}, [formData]);
	const manageSubmit = () => {
		//setBackDrop(true);
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },

			body: JSON.stringify({
				pwd: formData.pwd1,
				pwd2: formData.pwd2,
			}),
		};

		fetch("/api/9958c51b8d4349aab6d9e9d5abe4d130", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						location.replace(props.r !== undefined ? props.r : "/dashboard");
						break;

					case "err":
						//setBackDrop(false);
						//setErr(res.reason);

						break;
					default:
						break;
				}
			});
	};

	////////////
	const [values, setValues] = useState({
		showPassword: false,
	});
	const handleClickShowPassword = () => {
		setValues({ ...values, showPassword: !values.showPassword });
	};
	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	////////

	return (
		<Box display="flex" justifyContent="center" alignItems="center">
			<Box>
				<Paper style="margin: 10px; padding: 10px; max-width: 600px;">
					<CollapseInfos
						collapse={{
							open: true,
							noclose: true,
							mess: (
								<Typography variant="body1">
									Avant de pouvoir utiliser Bkeys, vous devez renseigner un mot de passe pour votre compte pour pouvoir accéder à
									votre espace.
								</Typography>
							),
						}}
						setCollapse={undefined}
					/>
					<div>
						<Typography variant="h5">Tous les champs sont obligatoires</Typography>
					</div>
					<div >
						<Box display="flex" alignItems="center" justifyContent="space-between" p={1} m={1} style="padding: 0px; margin: 0px;">
							<Box p={1} style="padding: 0px; margin: 0px; flex-grow: 1;">
								<TextField
									id="pwd1"
									name="pwd1"
									variant="outlined"
									style={{
										marginLeft: 0,
										marginRight: 10,
									}}
									placeholder="Mot de passe (6 caractères min)"
									fullWidth
									margin="dense"
									size="small"
									value={formData.pwd1}
									onChange={handleChange}
									type={values.showPassword ? "text" : "password"}
								/>
							</Box>
							<Box p={1}>
								<Tooltip title={values.showPassword ? "Masquer le mot de passe" : "Voir le mot de passe"} aria-label="add">
									<IconButton aria-label="mot de passe " onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword}>
										{values.showPassword ? <Visibility /> : <VisibilityOff />}
									</IconButton>
								</Tooltip>
							</Box>
						</Box>
					</div>
					<div>
						<TextField
							id="pwd2"
							name="pwd2"
							variant="outlined"
							style={{
								marginLeft: 0,
								marginRight: 10,
							}}
							placeholder="Confirmation du mot de passe"
							fullWidth
							margin="dense"
							size="small"
							value={formData.pwd2}
							onChange={handleChange}
							type={values.showPassword ? "text" : "password"}
						/>
					</div>
					<div>
						<Typography variant="caption">
							Le mot de passe doit faire 6 caractères minimum et contenir au moins une majuscule, un chiffre et un caractère{" "}
							<span
								onClick={() =>
									setFormData({
										...formData,
										pwd1: "Aqwaqw&1",
										pwd2: "Aqwaqw&1",
									})
								}
							>
								spécial
							</span>
						</Typography>
					</div>
					<div>
						<Box display="flex" alignItems="center" justifyContent="center" p={1} m={1} style="padding: 0px; margin: 0px;">
							<Box p={1} style="padding: 0px; margin: 0px; ">
								<Button onClick={manageSubmit} disabled={!complete} variant="contained">Définir le mot de passe</Button >
							</Box>
						</Box>
					</div>
				</Paper>
			</Box>
		</Box>
	);
}
